import Vue from 'vue'
import Router from 'vue-router'

// Containers
const DefaultContainer = () => import('@/containers/DefaultContainer')

// Views
const Dashboard = () => import('@/views/Dashboard')
const Login = () => import('@/views/Login')
const Settings = () => import('@/views/Settings')
const History = () => import('@/views/History')
const AdminList = () => import('@/views/AdminList')
const UnitList = () => import('@/views/UnitList')
const Company = () => import('@/views/Company')
const Role = () => import('@/views/Role')

Vue.use(Router)

export default new Router({
  mode: 'hash',
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      name: '登入',
      component: Login
    },
    {
      path: '/_admin_',
      name: '管理員登入',
      component: Login,
    },
    {
      path: '/dashboard',
      name: '頂層',
      component: DefaultContainer,
      children: [
        {
          path: 'home',
          name: '主控板',
          component: Dashboard
        },
        {
          path: 'settings',
          name: '裝置設定',
          component: Settings
        },
        {
          path: 'history',
          name: '歷史紀錄',
          component: History
        },
        {
          path: 'admins',
          name: '管理員列表',
          component: AdminList
        },
        {
          path: 'units',
          name: '單位列表',
          component: UnitList
        },
        {
          path: 'companies',
          name: '公司列表',
          component: Company
        },
        {
           path: 'roles',
           name: '角色列表',
           component: Role
        },
      ]
    },
  ]
})
